import React from 'react';
import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Typography,
} from '@mui/material';

import LiveFeedViewer from './LiveFeedViewer';

const LivePreviewDialog = ({ camera, open, onClose, apiBase }) => (
  <Dialog open={open} onClose={onClose} fullWidth maxWidth="md">
    <DialogTitle>
      {camera ? `Live view \u2014 ${camera.name || `Camera ${camera.id}`}` : 'Live view'}
    </DialogTitle>
    <DialogContent dividers sx={{ p: 0 }}>
      {camera ? (
        <Box sx={{ display: 'flex', flexDirection: 'column' }}>
          <LiveFeedViewer cameraId={camera.id} apiBase={apiBase} />
          {camera.location ? (
            <Box sx={{ p: 2 }}>
              <Typography variant="body2" color="text.secondary">
                Location: {camera.location}
              </Typography>
            </Box>
          ) : null}
        </Box>
      ) : (
        <Box sx={{ p: 3 }}>
          <Typography variant="body2" color="text.secondary">
            Select a camera to preview its live feed.
          </Typography>
        </Box>
      )}
    </DialogContent>
    <DialogActions>
      <Button onClick={onClose}>Close</Button>
    </DialogActions>
  </Dialog>
);

export default LivePreviewDialog;
